// extracted by mini-css-extract-plugin
export default {"mD":"registrationStatus_mD__EYFEj"};